module.exports = __webpack_public_path__ + "static/img/67-1.ca7b626.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/67-1.jpg
// module id = Nr4K
// module chunks = 0